export default __webpack_public_path__ + "static/media/autodiagnostic.7e19d959.xlsx";